var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.571,
    height: 48.001,
    viewBox: "0 0 53.571 48.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44417",
    "data-name": "Group 44417",
    transform: "translate(-6396.712 4886.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26658",
    "data-name": "Path 26658",
    d: "M4.929,170.1a.958.958,0,0,0,.958-.958v-.958h.958a.958.958,0,1,0,0-1.916H5.887v-.955a.958.958,0,0,0-1.916,0v.958H3.013a.958.958,0,0,0,0,1.916h.958v.958a.958.958,0,0,0,.958.955",
    transform: "translate(6396.71 -5044)",
    fill: "#ff7b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26659",
    "data-name": "Path 26659",
    d: "M13.542,190.457a5.724,5.724,0,1,0,5.738,5.737,5.724,5.724,0,0,0-5.738-5.737",
    transform: "translate(6396.71 -5044)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26660",
    "data-name": "Path 26660",
    d: "M33.687,196.194a5.739,5.739,0,1,0,5.741-5.737h0a5.721,5.721,0,0,0-5.739,5.7v.034",
    transform: "translate(6396.71 -5044)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26661",
    "data-name": "Path 26661",
    d: "M39.456,164.924a7.651,7.651,0,0,0,10.7,10.936l.118-.118c2.988-2.988,2.241-13.059,2.241-13.059s-10.074-.746-13.062,2.241",
    transform: "translate(6396.71 -5044)",
    fill: "#f2d3cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26662",
    "data-name": "Path 26662",
    d: "M16.159,162.6a2.874,2.874,0,1,0,2.874-2.874,2.874,2.874,0,0,0-2.874,2.874m3.832,0a.958.958,0,1,1-.958-.958.958.958,0,0,1,.958.958",
    transform: "translate(6396.71 -5044)",
    fill: "#c5c5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26663",
    "data-name": "Path 26663",
    d: "M52.624,158.09c-1.036-.076-10.221-.661-13.313,2.423a8.19,8.19,0,0,0-2.431,5.845,8.41,8.41,0,0,0,.479,2.748H21.338a4.614,4.614,0,0,0-3.836,2.058l-6.281,9.4a.925.925,0,0,0-.118.276A15.689,15.689,0,0,0,0,195.817a4.627,4.627,0,0,0,4.611,4.619H6.182a7.2,7.2,0,0,0,5.807,3.679,7.207,7.207,0,0,0,5.807-3.68H32a7.2,7.2,0,0,0,5.8,3.68,7.2,7.2,0,0,0,5.806-3.679h1.569a4.669,4.669,0,0,0,4.646-4.634V184.764a4.641,4.641,0,0,0-4.646-4.6H42.438v-6a8.44,8.44,0,0,0,2.753.48,8.269,8.269,0,0,0,5.863-2.422c3.091-3.084,2.5-12.247,2.426-13.282a.925.925,0,0,0-.856-.85M13.715,180.163l5.323-7.976a2.769,2.769,0,0,1,2.3-1.238h4.478v9.215h-12.1Zm-1.6,22.076a4.7,4.7,0,0,1-4.4-3.066A4.509,4.509,0,0,1,12,193.044a4.712,4.712,0,0,1,4.728,4.6c0,.514-.15,1.029-.15,1.531a5.07,5.07,0,0,1-4.463,3.064Zm25.687,0a4.619,4.619,0,1,1,4.34-3.066,4.618,4.618,0,0,1-4.34,3.066m10.177-17.475V195.8a2.822,2.822,0,0,1-2.8,2.791h-.987a4.12,4.12,0,0,0,.067-.934,6.455,6.455,0,1,0-12.91,0,4.094,4.094,0,0,0,.067.931H18.378a4.12,4.12,0,0,0,.067-.934,6.455,6.455,0,0,0-12.911,0,4.069,4.069,0,0,0,.068.941H4.613a2.779,2.779,0,0,1-2.765-2.775,13.842,13.842,0,0,1,13.829-13.813h29.5a2.791,2.791,0,0,1,2.8,2.756m-7.387-11.038v6.436H27.664v-9.214H37.8a2.757,2.757,0,0,1,.512.062c.12.175.247.351.381.518L36.7,173.519a.923.923,0,0,0,1.306,1.3L40,172.835c.167.134.35.258.525.377a2.7,2.7,0,0,1,.065.514m9.151-2.807A6.477,6.477,0,0,1,42.074,172a4.7,4.7,0,0,0-.426-.821l1.148-1.156h5.15a.921.921,0,1,0,0-1.843h-3.3l3.8-3.778a.915.915,0,0,0-1.294-1.3l-3.79,3.792v-3.294a.924.924,0,1,0-1.847,0v5.137l-1.161,1.15a4.573,4.573,0,0,0-.825-.427,6.417,6.417,0,0,1,1.089-7.648c1.608-1.6,6.137-1.97,9.352-1.97.632,0,1.212.015,1.71.036.135,3.02-.014,9.109-1.938,11.033Z",
    transform: "translate(6396.71 -5044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26664",
    "data-name": "Path 26664",
    d: "M3.048,182.052a.578.578,0,0,1-.408-.169l-1.3-1.3a.577.577,0,0,1,0-.816h0l1.3-1.3a.577.577,0,0,1,.816,0h0l1.3,1.3a.577.577,0,0,1,0,.816h0l-1.3,1.3a.572.572,0,0,1-.409.169m-.487-1.882.487.487.488-.487-.488-.487Z",
    transform: "translate(6396.71 -5044)",
    fill: "#6583fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26665",
    "data-name": "Path 26665",
    d: "M49.561,206a.578.578,0,0,1-.408-.169l-1.3-1.3a.577.577,0,0,1,0-.816h0l1.3-1.3a.577.577,0,0,1,.816,0h0l1.3,1.3a.577.577,0,0,1,0,.816h0l-1.3,1.3a.58.58,0,0,1-.409.169m-.488-1.882.487.488.487-.488-.487-.487Z",
    transform: "translate(6396.71 -5044)",
    fill: "#6583fe"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvHover);
export default __webpack_public_path__ + "static/media/evHover.942ff8e750a64743ff9f76bba1c7ce13.svg";
export { ForwardRef as ReactComponent };